/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { DeleteCollectionPatternMutation, DeleteCollectionPatternMutationVariables } from "@models/graphql";

const defaultDeleteCollectionPatternOptions: MutationHookOptions<
    DeleteCollectionPatternMutation,
    DeleteCollectionPatternMutationVariables
> = {};

export const useDeleteCollectionPattern = (
    options?: MutationHookOptions<DeleteCollectionPatternMutation, DeleteCollectionPatternMutationVariables>
) => {
    const [mutation, { data, loading, error }] = useMutation<DeleteCollectionPatternMutation, DeleteCollectionPatternMutationVariables>(
        GraphQLDocuments.deleteCollectionPattern
    );

    const deleteCollectionPattern = async (variables: DeleteCollectionPatternMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultDeleteCollectionPatternOptions,
                ...options,
                variables
            });

            return {
                data: response.data,
                error: response.errors
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        deleteCollectionPattern
    };
};
